import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">热门榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网用户关注度最高的影视内容排行</p>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300/60 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold font-heading ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-400">{item.category}</span>
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="text-sm font-semibold text-accent-600 whitespace-nowrap flex-shrink-0">{item.heat}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}